// extracted by mini-css-extract-plugin
export default {"noDataText":"ProductBuildSearchResults_noDataText__097Jv","sortContainer":"ProductBuildSearchResults_sortContainer__lIobB"};